export enum CHECKOUT_COM_CARD_FORM_STATES {
  INITIAL = 'INITIAL',
  ERROR = 'ERROR',
  CARD_TOKENIZED = 'CARD_TOKENIZED',
  '3D_SECURE_OPEN' = '3D_SECURE_OPEN',
  '3D_SECURE_SUCCEEDED' = '3D_SECURE_SUCCEEDED',
  // Flow-based states (new)
  FLOW_READY = 'FLOW_READY',
  FLOW_PAYMENT_COMPLETED = 'FLOW_PAYMENT_COMPLETED',
}
